import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatTokenCount } from '../../Utils/workflowTokenUsage';

export default function ConnectorPreparationMetrics({ step, state, compact = false }) {
  const { t, i18n } = useTranslation();
  const native = step?.native;
  const metrics = state?.metrics;
  const noAi = native || ['condition', 'deduplicate'].includes(step?.operation);
  const unknown = t('connector_setup.step.unknown');
  const amount = (value) => value == null ? unknown : formatTokenCount(value, i18n.language);
  const rows = [
    ['input', state ? amount(state.entered) : unknown],
    ['output', state ? amount(state.passed) : unknown],
    ['excluded', state ? amount(state.counts?.drop || 0) : unknown],
    ['ai_cost', noAi ? t('connector_setup.step.no_ai') : t('connector_setup.step.cost_unavailable')],
  ];
  return <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: compact ? 1 : 2 }}>
    {state?.indexing && <Typography variant="caption" sx={{ gridColumn: '1 / -1' }}>{t('connector_setup.step.partial_counts')}</Typography>}
    {rows.map(([key, value]) => <Box key={key}>
      <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>{t(`connector_setup.step.${key}`)}</Typography>
      <Typography variant={compact ? 'caption' : 'body2'} sx={{ fontWeight: 700 }}>{value}</Typography>
    </Box>)}
    {metrics?.total_tokens != null && <Box sx={{ gridColumn: '1 / -1' }}>
      <Typography variant="caption">{t('connector_setup.step.tokens', {
        input: amount(metrics.input_tokens), output: amount(metrics.output_tokens), requests: amount(metrics.request_count),
      })}</Typography>
      {Number(metrics.measured_items || 0) < Number(state?.entered || 0) && <Typography variant="caption" sx={{ display: 'block' }}>
        {t('connector_setup.step.partial_usage')}
      </Typography>}
    </Box>}
    {metrics?.duration_ms != null && <Typography variant="caption" sx={{ gridColumn: '1 / -1' }}>
      {t('connector_setup.step.duration', { seconds: (metrics.duration_ms / 1000).toLocaleString(i18n.language, { maximumFractionDigits: 1 }) })}
    </Typography>}
  </Box>;
}
